/**
 * The short ID employees quote ("question d2de109f") – the first eight
 * characters, mono. A click copies the full ID; the tooltip shows it.
 */
import { clsx } from "clsx";

import { useToast } from "./toast/context";

export function ShortId({ id, className }: { id: string | null | undefined; className?: string }) {
  const toast = useToast();
  if (!id) return null;
  const short = id.slice(0, 8);
  return (
    <button
      type="button"
      className={clsx("short-id", className)}
      title={`${id} – click to copy`}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        navigator.clipboard.writeText(id).then(
          () => toast.ok(`Copied ID ${short}`),
          () => toast.error("Could not copy the ID"),
        );
      }}
    >
      {short}
    </button>
  );
}
